import React from "react";
import { Helmet } from "react-helmet";
import PropTypes from "prop-types";
import { Fragment } from "react";
// import Header from "components/Header";
// import AppBar from "components/AppBar";
import { Content } from "./styles";
import AppBar2 from "components/AppBar2";

function Layout({ title, children }) {
  const pageTitle = title ? `${title} - Savant` : "Savant";

  return (
    <Fragment>
      <Helmet>
        <title>{pageTitle}</title>
      </Helmet>
      <AppBar2 />
      {/* <AppBar /> */}
      {/* <Header /> */}
      <Content>{children}</Content>
    </Fragment>
  );
}

Layout.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default Layout;
